"use client";

import { getToken, getMessaging } from "firebase/messaging";

import firebaseApp from "@/firebase/config";
import { updateFCMToken } from "@/services/controllers/notifications";

const firebaseCloudMessaging = {
  init: async () => {
    try {
      // Request the push notification permission from browser
      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const messaging = getMessaging(firebaseApp);
        const fcm_token = await getToken(messaging, {
          vapidKey: process.env.NEXT_PUBLIC_VAPID!,
        });
        const savedToken = window.localStorage.getItem("fcm_token");
        // Set token in our local storage
        if (fcm_token !== savedToken) {
          window.localStorage.setItem("fcm_token", fcm_token as any);
          updateFCMToken(fcm_token as any);
          return fcm_token;
        }
      }
    } catch (_) {
      return _;
    }
  },
};
export { firebaseCloudMessaging };
